import { Text } from '@pairy/pds-react';
import Image from 'next/image';

import handleFreeBadgeLinkOpen from '../../../../utils/handleFreeBadgeLinkOpen';

import * as Styled from './index.styles';

interface Props {
  userSubscriptionPlan: string;
}

const DesktopFreeBadge = ({ userSubscriptionPlan }: Props) => {
  const isFreeBadgeVisible = () => {
    return userSubscriptionPlan === 'Free';
  };

  return (
    <Styled.Container
      gap={8}
      className={isFreeBadgeVisible() ? 'is-visible' : ''}
      padding={{ x: 24, y: 16 }}
      alignItems="center"
      width="fit-content"
      style={{ transform: 'scale(1.2) translate(-18px, -5px)' }}
      onClick={() => {
        handleFreeBadgeLinkOpen();
      }}
    >
      <Text variant="lg-semibold" color="skyblue_100">
        Powered by
      </Text>
      <Image
        src="/images/salesclue_logo_black_mono.png"
        width={94}
        height={21}
        alt={'SalesClue'}
        unoptimized
      />
    </Styled.Container>
  );
};

export default DesktopFreeBadge;
